(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dms-header"]) return;
  try {
    
  if(!customElements.get('dms-header')){
    customElements.define('dms-header',class extends HTMLElement{
      connectedCallback(){
        this.controller?.abort();
        this.controller=new AbortController();
        const signal=this.controller.signal;
        const menu=this.querySelector('details');
        if(!menu)return;
        menu.addEventListener('click',event=>{if(event.target.closest('a'))menu.open=false;},{signal});
        menu.addEventListener('keydown',event=>{if(event.key==='Escape'){menu.open=false;menu.querySelector('summary').focus();}},{signal});
        document.addEventListener('click',event=>{if(!this.contains(event.target))menu.open=false;},{signal});
      }
      disconnectedCallback(){this.controller?.abort();}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dms-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dms-product')) {
    customElements.define('dms-product', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.form = this.querySelector('form');
        this.quantity = this.form?.elements.quantity;
        this.variantInput = this.form?.elements.id;
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.gallery = this.querySelector('[data-gallery]');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.thumbs = [...this.querySelectorAll('[data-thumb]')];
        this.index = 0;
        this.thumbs.forEach(button=>button.addEventListener('click',()=>this.showImage(Number(button.dataset.thumb)),{signal}));
        this.gallery?.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.showImage((this.index+(e.key==='ArrowRight'?1:-1)+this.slides.length)%this.slides.length);}},{signal});
        this.gallery?.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>{this.index=Math.round(this.gallery.scrollLeft/this.gallery.clientWidth);this.thumbs.forEach((b,i)=>{b.classList.toggle('is-active',i===this.index);b.setAttribute('aria-pressed',String(i===this.index));});const count=this.querySelector('[data-slide-count]');if(count)count.textContent=String(this.index+1);});},{signal,passive:true});
        this.querySelector('[data-quantity-minus]')?.addEventListener('click',()=>{this.quantity.stepDown();this.clampQuantity();},{signal});
        this.querySelector('[data-quantity-plus]')?.addEventListener('click',()=>{this.quantity.stepUp();this.clampQuantity();},{signal});
        this.quantity?.addEventListener('change',()=>this.clampQuantity(),{signal});
        this.variantInput?.addEventListener('change',()=>this.updateVariant(),{signal});
        this.form?.addEventListener('submit',e=>this.add(e),{signal});
        this.querySelectorAll('[data-close]').forEach(b=>b.addEventListener('click',()=>this.querySelector('[data-confirm]').close(),{signal}));
        const atc=this.querySelector('.dms-atc');
        if(atc&&'IntersectionObserver' in window){this.observer=new IntersectionObserver(entries=>{const r=entries[0].boundingClientRect;const mobile=window.matchMedia('(max-width:749px)').matches;this.querySelector('[data-sticky]').hidden=entries[0].isIntersecting||(!mobile&&r.bottom>0);},{threshold:0});this.observer.observe(atc);}
      }
      disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame);this.initialized=false;}
      showImage(index){this.gallery.scrollTo({left:this.gallery.clientWidth*index,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
      clampQuantity(){const min=Number(this.quantity.min)||1;const step=Number(this.quantity.step)||1;const max=this.quantity.max?Number(this.quantity.max):Infinity;const value=Number(this.quantity.value);this.quantity.value=String(Math.min(max,Math.max(min,min+Math.round(((Number.isFinite(value)?value:min)-min)/step)*step)));}
      updateVariant(){const variant=this.variants.find(v=>String(v.id)===this.variantInput.value);if(!variant)return;this.querySelector('[data-price]').textContent=variant.price;this.querySelector('[data-sticky-price]').textContent=variant.price;this.querySelector('[data-compare]').textContent=variant.compare;this.querySelector('[data-compare]').hidden=!variant.onSale;this.querySelector('[data-saving]').hidden=!variant.onSale;this.quantity.min=variant.min;this.quantity.step=variant.step;if(variant.max)this.quantity.max=variant.max;else this.quantity.removeAttribute('max');this.clampQuantity();this.setBusy(false);}
      setBusy(busy){const variant=this.variants.find(v=>String(v.id)===this.variantInput.value);this.querySelectorAll('.dms-atc,[data-sticky-submit]').forEach(button=>{button.disabled=busy||!variant?.available;button.setAttribute('aria-busy',String(busy));});const label=busy?this.dataset.loadingLabel:variant?.available?this.dataset.addLabel:this.dataset.soldLabel;this.querySelectorAll('[data-submit-text],[data-sticky-text]').forEach(e=>e.textContent=label);}
      async add(event){event.preventDefault();if(this.busy||!this.form.reportValidity())return;this.busy=true;this.setBusy(true);const error=this.querySelector('[data-error]');error.hidden=true;try{const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{Accept:'application/json'},body:new FormData(this.form)});const result=await response.json();if(!response.ok)throw new Error(result.description||result.message||this.dataset.errorLabel);const dialog=this.querySelector('[data-confirm]');if(typeof dialog.showModal==='function')dialog.showModal();else window.location.assign(this.dataset.cartUrl);try{const cartResponse=await fetch(this.dataset.cartUrl+'.js',{headers:{Accept:'application/json'}});if(cartResponse.ok){const cart=await cartResponse.json();document.querySelectorAll('[data-dms-cart-count]').forEach(e=>e.textContent=cart.item_count);}}catch{}}catch(err){error.textContent=err.message||this.dataset.errorLabel;error.hidden=false;error.scrollIntoView({block:'center',behavior:'smooth'});}finally{this.busy=false;this.setBusy(false);}}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
